import { Resources } from 'constants/resources';
import { Role } from 'constants/roles';

import { useState } from 'react';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useApiContext } from 'context/apiContext';
import { usePermissions } from 'hooks/usePermissions';
import { useGetMany, useListContext } from 'react-admin';
import { Button } from 'shared/mui/Buttons';
import { ProviderAccount } from 'types/embedded/providerAccount';
import { convertReactAdminIdToHydraId } from 'utils/convertReactAdminIdToHydraId';

import { WorkTeamUsersBulkAddDialog } from './WorkTeamUsersBulkAddDialog/WorkTeamUsersBulkAddDialog';

export const ProviderAccountsListBulkActions: React.FC = () => {
  const { selectedIds } = useListContext();
  const { user } = useApiContext();
  const { isHaveRole } = usePermissions();

  const [isOpenBulkAddDialog, setIsOpenBulkAddDialog] = useState(false);

  const { data: selectedProviderAccounts = [] } = useGetMany<ProviderAccount>(
    Resources.ProviderAccounts,
    { ids: selectedIds },
    { enabled: selectedIds.length > 0 },
  );

  const workTeam = selectedProviderAccounts[0]?.workTeam;
  const hasCommonWorkTeam =
    !!workTeam &&
    selectedProviderAccounts.every(
      (providerAccount) => providerAccount.workTeam?.['@id'] === workTeam['@id'],
    );
  const isWorkTeamManager =
    workTeam?.manager?.['@id'] === convertReactAdminIdToHydraId(user.id, 'users');
  const canAddMembers =
    isHaveRole([Role.Admin, Role.Tech]) || (isHaveRole([Role.FinanceLead]) && isWorkTeamManager);

  return (
    <>
      <Button
        disabled={!hasCommonWorkTeam || !canAddMembers}
        label="Добавить ответственных"
        onClick={() => setIsOpenBulkAddDialog(true)}
        startIcon={<AddCircleOutlineIcon />}
      />
      {isOpenBulkAddDialog && (
        <WorkTeamUsersBulkAddDialog
          onClose={() => setIsOpenBulkAddDialog(false)}
          open={isOpenBulkAddDialog}
          providerAccounts={selectedProviderAccounts}
        />
      )}
    </>
  );
};
